import React from "react";
import "./App.css";
import "antd/dist/antd.css";
import Routes from "./Routes";

function App() {
    return (
        <div className="app">
            <Routes />
        </div>
    );
}

export default App;
